import { React, useState, useEffect } from "react";
import MiscUploadPDFView from "../misc_components/MiscUploadPDFView";
import Footer from "../Footer";
import NavBar from "../NavBar";
import MiscPageTitle from "../misc_components/MiscPageTitle";
import MiscPageMidSection from "../misc_components/MiscPageMidSection";
import HomeScreenHowToUse from "../home_screen/HomeScreenHowToUse";
import MiscWhyUse from "../misc_components/MiscWhyUse";
import MiscPageLookingFor from "../misc_components/MiscPageLookingFor";
import LoadingBar from "react-top-loading-bar";
import { useLocation, ScrollRestoration } from "react-router-dom";
import { PageContext } from "../../App";
import PDFViewerView from "./PDFViewerView";
import { BASE_URL } from "../Config";

function PDFViewerMain() {
  //location
  const location = useLocation();
  // Use optional chaining or a guard in case state is undefined
  const { title } = location.state || { title: "PDF Viewer & PDF Reader" };

  //selected files
  const [selectedFiles, setSelectedFiles] = useState([]);
  //show edit screen
  const [showEditFileScreen, setShowEditFileScreen] = useState(false);
  //start processing
  const [startProcessingFiles, setStartProcessingFiles] = useState(false);

  //looking for object
  //requires 3 data objects
  //to show keywarded navigation
  const lookingForObject = {
    data1: { link: "/pdf_viewer", title: "PDF Viewer" },
    data2: { link: "/pdf_viewer", title: "PDF Reader" },
    data3: { link: "/pdf_viewer", title: "Open PDF Documents Online" },
  };

  //use effect to handle the submit button click
  useEffect(() => {
    //check
    if (startProcessingFiles === true) {
      //show file edit screen
      setShowEditFileScreen(true);

      console.log(
        "Start file processing. Number of files: ",
        selectedFiles.length
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [startProcessingFiles]);

  return (
    <PageContext
      value={{
        selectedFiles,
        setSelectedFiles,
        startProcessingFiles,
        setStartProcessingFiles,
        setShowEditFileScreen,
      }}
    >
      {/* Scroll to top */}
      <ScrollRestoration />
      {/* Loading Bar */}
      <LoadingBar />

      {/*Add title and metadata */}
      <title>{title + " Offline"}</title>
      <meta name="robots" content="index, follow"></meta>
      <link
        rel="canonical"
        href={`${BASE_URL}${lookingForObject.data1.link}`}
      />
      <meta
        name="description"
        content="View PDF online instantly. Open, read, and navigate PDF documents quickly with our fast, secure, and user-friendly PDF viewer tool."
      ></meta>
      <meta
        name="keywords"
        content="pdf viewer, view pdf online, open pdf online, read pdf online, online pdf reader, pdf reader tool, pdf document viewer, fast pdf viewer, secure pdf viewer, pdf navigation tool, online pdf tool, pdf viewer free, pdf file reader, pdf document reader, pdf editor online"
      ></meta>

      {/* page content */}
      {showEditFileScreen ? (
        <PDFViewerView
          title={title}
          onClose={() => {
            //set flags
            setSelectedFiles([]);
            setShowEditFileScreen(false);
            setStartProcessingFiles(false);
          }}
          file={selectedFiles.length > 0 ? selectedFiles[0] : null}
        ></PDFViewerView>
      ) : (
        <div>
          {/* Nav Bar */}
          <NavBar />
          {/* Title */}
          <MiscPageTitle title={title} online={false} />
          {/* Upload PDF View */}
          <MiscUploadPDFView
            selectMultiple={false}
            filetype={{ "application/pdf": [".pdf"] }}
          />
          {/* Mid Section */}
          <MiscPageMidSection description="Our PDF Reader website offers a fast, lightweight, and secure solution for viewing PDF files without requiring an internet connection. Built to work fully offline, this powerful tool allows users to open, read, and navigate PDF documents directly on their device, ensuring complete privacy and data protection. Whether you are reading eBooks, manuals, reports, invoices, or academic documents, this offline-ready PDF reader delivers smooth performance with clear text rendering and accurate page layout. The website also supports optional online access, giving users the flexibility to use it as a PDF viewer online or a fully offline application depending on their needs. With intuitive navigation, zoom controls, search functionality, and page thumbnails, users can easily read and manage documents using a reliable PDF reader online or offline. Optimized for speed and compatibility, the platform opens large PDF files quickly while preserving fonts, images, and formatting. Ideal for students, professionals, and everyday users, this website provides a secure and user-friendly way to read PDFs anytime, anywhere. If you are looking for a dependable PDF reader online, a lightweight PDF viewer online, or a privacy-focused offline PDF reading solution, this platform offers an seamless document viewing experience." />
          {/* How to use */}
          <HomeScreenHowToUse
            steps={{
              step1: "Select",
              step2: "Offline",
              step3: "Open",
              step4: "View",
            }}
          />
          {/* Why use section */}
          <MiscWhyUse
            title="PDF Reader"
            why_use={[
              {
                title: "Open and Read PDF Files Easily",
                description:
                  "Our PDF reader allows users to open and read PDF documents smoothly without layout or formatting issues.",
              },
              {
                title: "Access Documents Offline Anytime",
                description:
                  "This offline PDF reader lets you view important PDF files without internet access, ideal for work, study, and travel.",
              },
              {
                title: "Universal Document Compatibility",
                description:
                  "Our reliable PDF reader online ensures PDFs display consistently across different devices and operating systems.",
              },
              {
                title: "Fast and Lightweight Performance",
                description:
                  "Modern PDF reader tools open large PDF files quickly while maintaining clear text and high image quality.",
              },
              {
                title: "Perfect for Students and Professionals",
                description:
                  "Students and professionals rely on PDF viewer online and offline tools to read books, notes, reports, and contracts.",
              },
              {
                title: "Secure Viewing of Sensitive Files",
                description:
                  "Using an offline PDF reader keeps confidential documents secure by avoiding online uploads.",
              },
              {
                title: "Easy Search and Navigation",
                description:
                  "Our PDF reader online provides search, zoom, bookmarks, and page navigation for a better reading experience.",
              },
              {
                title: "Preserve Original Formatting",
                description:
                  "This quality PDF reader maintains original fonts, layouts, and images exactly as designed in the document.",
              },
              {
                title: "Read PDFs Anytime, Anywhere",
                description:
                  "With an offline PDF reader, users can access and read PDF documents anytime without internet dependency.",
              },
            ]}
          />
          {/* Looking for section */}
          <MiscPageLookingFor data={lookingForObject} />
          {/* Footer */}
          <Footer />
        </div>
      )}
    </PageContext>
  );
}

export default PDFViewerMain;
